export default async function postData(dataUrl: string, dataObj?: object) {
    try {
        const data = await window.fetch(dataUrl, dataObj);
        return await data.json();
    } catch (error) {
        return error.message;
    }
}
